"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagDisplay = void 0;
var react_1 = __importDefault(require("react"));
var Typo2_1 = require("../../../Typo2");
var Tag_1 = require("../Tag");
var themes_1 = require("../../../../themes");
var getTagDisplayStyles_1 = require("./getTagDisplayStyles");
var white = themes_1.colors.white;
var TagDisplay = function (_a) {
    var id = _a.id, display = _a.display, size = _a.size, 
    // tagColor,
    // textColor,
    fill = _a.fill, icon = _a.icon, _b = _a.colorPreset, colorPreset = _b === void 0 ? 'default' : _b, weight = _a.weight;
    return (react_1.default.createElement(Tag_1.Tag, { weight: weight, id: id, display: display, icon: icon, size: size, fill: fill, style: __assign({ padding: "0.25rem 0.5rem", borderRadius: "4px", color: white }, (0, getTagDisplayStyles_1.getTagDisplayStyles)({ colorPreset: colorPreset })), typo: Typo2_1.UI_TAG_DF }));
};
exports.TagDisplay = TagDisplay;
